<template>
  <div class="s-cards__head">
    <div class="s-cards__head__title-row">
      <h2 v-if="dictionary.title" class="s-cards__head__title">
        {{ dictionary.title }}
      </h2>
      <div v-if="cinemas.length > 0" class="s-cards__head__filter">
        <select
          v-model="selectedCinema"
          class="form-select"
          @change="filterRecords">
          <option value="all">{{ dictionary.allCinemas }}</option>
          <option
            v-for="cinema in cinemas"
            :key="cinema.value"
            :value="cinema.value">
            {{ cinema.display }}
          </option>
        </select>
      </div>
    </div>
    <p v-if="dictionary.description" class="s-cards__head__description">
      {{ dictionary.description }}
    </p>
  </div>
  <div class="s-cards__body s-cards__body--three-cols">
    <div
      v-for="record in filteredRecords"
      :key="record.id"
      class="b-frame-card b-frame-card--white">
      <div class="b-frame-card__img">
        <a v-if="record.image" :href="record.url">
          <img
            :src="record.image?.url"
            :alt="record.image?.alt"
            :width="record.image?.width"
            :height="record.image?.height" />
        </a>
      </div>
      <div class="b-frame-card__content">
        <h3 v-if="record.title" class="b-frame-card__title">
          {{ record.title }}
        </h3>
        <p v-if="record.description" class="b-frame-card__text">
          {{ record.description }}
        </p>
        <div v-if="record.url" class="b-frame-card__btn-area">
          <a :href="record.url" class="b-frame-card__cta"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { getData } from '../../lib/lib'

const { dictionary, filters, records } = getData('cinemaRoomTypeData')

const cinemas = filters?.cinemas || []
const selectedCinema = ref('all')

const filteredRecords = computed(() => {
  if (selectedCinema.value === 'all') {
    return records
  }
  return records.filter((record) =>
    record.cinemas?.includes(selectedCinema.value)
  )
})

const filterRecords = () => {
  // Trigger reactivity if needed
}
</script>
